<template>
  <div :class="cssClasses.mediaContentBox" :style="boxStyles" @click="goToLink">
    <component :is="'iframe'" allowfullscreen v-if="isEmbededVideo" />
    <div :class="cssClasses.imageWrapper" v-else>
      <div ref="intersectObserver"></div>
      <img v-if="lazyload" :class="imageClasses" ref="mediaImgLazy" src="" :alt="alt" />
      <img
        v-else
        :class="cssClasses.imageClasses"
        ref="mediaImg"
        :src="mediaSrc"
        :alt="alt"
        @error="handleImageError"
      />
    </div>
    <slot />
  </div>
</template>

<script>
import MEDIA_CONSTANTS from '@/constants/media.constants.js';
export default {
  name: 'BrandMediaContentBox',
  props: {
    as: {
      type: String,
      default: MEDIA_CONSTANTS.MEDIA_CONTENT_TYPES.image,
      // validator: value => variationValidators(variations, value), // TODO: @Kuli, bu prop validasyonuna bakılacak!
    },
    aspectRatios: {
      type: String,
      default: MEDIA_CONSTANTS.MEDIA_ASPECT_RATIOS.by_1_1,
    },
    backgroundColor: {
      type: String,
    },
    mediaSrc: {
      type: String,
      default: '',
      required: true,
    },
    lazyload: {
      type: Boolean,
      default: true,
    },
    alt: {
      type: String,
    },
    href: {
      type: String,
      required: false,
      default: '',
    },
    isListelistImage: {
      type: Boolean,
      default: false,
    },
    bannerItem: {
      type: Object,
      required: false,
    },
    isSliderClick: {
      type: Boolean,
      default: false,
    },
    hideOnError: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imageClasses: [this.$style['image-item']],
      isHide: false,
    };
  },
  mounted() {
    if (!this.isEmbededVideo && this.lazyload) {
      this.$refs.mediaImgLazy.addEventListener('load', () => {
        this.imageClasses.push(this.$style[`image-item-loaded`]);
      });
      const observer = new IntersectionObserver(
        entries => {
          if (entries[0].isIntersecting) {
            if (this.$refs.mediaImgLazy) {
              this.$refs.mediaImgLazy.src = this.mediaSrc;
              observer.unobserve(this.$refs.intersectObserver);
            }
          }
        },
        { threshold: [0] },
      );
      observer.observe(this.$refs.intersectObserver);
    }
  },

  methods: {
    async goToLink() {
      this.$emit('onClickSliderContent', this.bannerItem);
      const originUrl = this.convertToOriginUrl();
      const reg = /(http(s?)):\/\//;

      if (this.href) {
        if (this.href.indexOf(originUrl) !== -1) {
          let newLink = this.href.replace(originUrl, '');
          this.$router.push(newLink);
        } else {
          window.location.href = reg.test(this.href) ? this.href : `https://${this.href}`;
        }
      }
    },

    convertToOriginUrl() {
      let origin = document.location.origin;

      const apiBaseUrl = process.env.VUE_APP_API_BASE_URL;
      const isDevOrQa = apiBaseUrl.includes('qa') || apiBaseUrl.includes('dev');

      const appendString = 'web';
      const splitURL = origin.split('//');

      return !isDevOrQa ? splitURL[0] + '//' + appendString + '.' + splitURL[1] : origin;
    },

    handleImageError() {
      if (this.hideOnError && !this.lazyload) {
        this.isHide = true;
      }
    },
  },
  computed: {
    cssClasses() {
      const imageWrapper = [this.$style['image-wrapper']];
      const imageClasses = [this.$style['image-item']];
      const mediaContentBox = [this.$style['media-content-box']];
      mediaContentBox.push(this.$style[`media-content-box-${this.aspectRatios}`]);
      if (!this.lazyload && this.mediaSrc) {
        imageClasses.push(this.$style[`image-item-loaded`]);
      }
      if (this.isListelistImage) {
        mediaContentBox.push(this.$style[`listelist-img`]);
      }
      if (this.hideOnError && !this.lazyload && this.isHide) {
        imageClasses.push(this.$style['hide']);
      }

      return { mediaContentBox, imageWrapper, imageClasses };
    },
    isEmbededVideo() {
      return this.as === MEDIA_CONSTANTS.MEDIA_CONTENT_TYPES.embed;
    },
    boxStyles() {
      const boxStyleObj = {};

      if (this.backgroundColor) {
        boxStyleObj.backgroundColor = this.backgroundColor;
      }

      return boxStyleObj;
    },
  },
};
</script>

<style module lang="scss">
.media-content-box {
  position: relative;
  display: flex;
  width: 100%;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  align-items: center;
  overflow: hidden;
  cursor: pointer;

  &:before {
    content: '';
    display: block;
  }

  iframe {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  figure {
    height: 100%;
    width: 100%;
    position: absolute;
  }
}
.image-wraper {
  display: flex;
  justify-content: center;
  align-items: center;
}
.image-wrapper {
  width: 100%;
  display: flex;
}
.image-item {
  min-height: 179px;
  object-fit: cover;
  width: 100%;
  transition: all 0.4s ease-in-out;
  opacity: 0;
  visibility: hidden;
  &-loaded {
    visibility: visible;
    opacity: 1;
  }
}

.media-content-box-1by1 {
  &:before {
    padding-top: 100%;
  }
}
.media-content-box-4by3 {
  &:before {
    padding-top: 75%;
  }
}
.media-content-box-16by9 {
  &:before {
    padding-top: 56.25%;
  }
  &.listelist-img {
    &:before {
      padding-top: 50%;
    }
  }
}
.media-content-box-21by9 {
  &:before {
    padding-top: 42.857143%;
  }
}
.hide {
  visibility: hidden;
}
</style>
